import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button, Notification } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGetRedeemPaperPrescription } from '../../../url-handling'

export const ProductBuyBoxRxCh: FC = () => {
  const i18n = useIntl()
  const globalConfig = useGlobalConfigContext()
  const mediserviceUrl = urlResolverGetRedeemPaperPrescription(globalConfig)

  return (
    <div className="w-full rounded-2xl bg-light-primary-medium px-4 pb-2.5 pt-5">
      <Notification
        className=""
        severity="info"
        title={i18n.formatMessage({
          id: 'chrx.product.buyBox.title',
        })}
        variant="secondary"
      >
        <FormattedMessage id="chrx.product.buyBox.message" />
      </Notification>

      <Button<'a'>
        className={clsx('w-full', 'whitespace-pre-wrap', 'mt-4')}
        data-qa-id="go-to-mediservice-button"
        endIcon={<IconArrowRight />}
        href={mediserviceUrl}
        slots={{ root: 'a' }}
      >
        <FormattedMessage id="general.link.label.recipe" />
      </Button>
    </div>
  )
}
